module.exports = __webpack_public_path__ + "/build/web/images/testimonials-right-2@3x.44f4ca4a48e5ad94c5b531d47a1f9019.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/testimonials-right-2@3x.jpg
// module id = 205
// module chunks = 13